import { t, Trans } from '@lingui/macro';
import FormSection from '../../form/FormSection';
import NgpFileUpload from '../../form/NgpFileUpload';
import NgpForm from '../../form/NgpForm';
import { SITE_IMPORT_FILE_FIELD } from './SiteAdminConstants';

export default function ImportDialogForm({ classes }) {
    return (
        <NgpForm initialized loading={false} showSave={false} formPadding={false} showRequiredFieldsTip={false}>
            <FormSection>
                <div className={classes.siteImportButtonContainer}>
                    <NgpFileUpload
                        label={t`Browse`}
                        fieldName={SITE_IMPORT_FILE_FIELD}
                        formSubmit
                        shrink
                        accept=".csv,.txt"
                    />
                </div>
                <div>
                    <li>
                        <Trans>The import file must be ASCII or Unicode text.</Trans>
                    </li>
                    <li>
                        <Trans>The file format must be comma or tab separated values.</Trans>
                    </li>
                    <li>
                        <Trans>The file&apos;s first line must be the header line. Headers are below:</Trans>
                    </li>
                </div>
                <div>
                    <ol>
                        <li>
                            <Trans>
                                <b>Name</b>: required, value: text
                            </Trans>
                        </li>
                        <li>
                            <Trans>Description: optional (retain value if blank), value: text</Trans>
                        </li>
                        <li>
                            <Trans>IpScopeDescription: optional (overwrite current value), value: text</Trans>
                        </li>
                        <li>
                            <Trans>
                                IpScope: optional (overwrite current value), value: IP address/IP Range/Subnet
                            </Trans>
                        </li>
                        <li>
                            <Trans>WanDeviceAddress: optional (overwrite current value), value: IP address</Trans>
                        </li>
                        <li>
                            <Trans>WanIfName: optional (overwrite current value), value: text</Trans>
                        </li>
                        <li>
                            <Trans>WanIfManualAdd: optional (default to false if blank), value: true/false</Trans>
                        </li>
                        <li>
                            <Trans>City: optional (retain value if blank), value: text</Trans>
                        </li>
                        <li>
                            <Trans>Province: optional (retain value if blank), value: text</Trans>
                        </li>
                        <li>
                            <Trans>Country: optional (retain value if blank), value: text</Trans>
                        </li>
                        <li>
                            <Trans>Latitude: optional (retain value if blank), value: number</Trans>
                        </li>
                        <li>
                            <Trans>Longitude: optional (retain value if blank), value: number</Trans>
                        </li>
                        <li>
                            <Trans>InSpeed: optional (retain value if blank), value: number</Trans>
                        </li>
                        <li>
                            <Trans>OutSpeed: optional (retain value if blank), value: number</Trans>
                        </li>
                        <li>
                            <Trans>Notes: optional (retain value if blank), value: text</Trans>
                        </li>
                        <li>
                            <Trans>Tags: optional (overwrite current value), value: text</Trans>
                        </li>
                    </ol>
                </div>
            </FormSection>
        </NgpForm>
    );
}
